import { Record } from "immutable";
import moment from "moment";

import UUID from "../utils/GenerateUUID";

const baseAction = "MODALS";

const ConfirmationModal = Record({
	id: UUID(),
	message: null,
	createdAt: null,
	action: () => {},
});

export function OpenModal() {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:OPEN` });
	};
}

export function CloseModal() {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:CLOSE` });
	};
}

export function DisplayConfirmationModal(message, action) {
	return (dispatch) => {
		const modal = new ConfirmationModal({
			message,
			action,
			createdAt: moment(),
		});

		dispatch({ type: `${baseAction}:OPEN`, modal });
	};
}
